import {Grid, TableContainer, TableBody, TableCell, TableHead, TableRow, Paper, Table, Tabs, Tab} from '@mui/material';
import {useTranslation} from "react-i18next";
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {getCityName, getCountryName, getSpecName} from '../Trans.js';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_MONTH} from './StatsCommon.js';
import StatsMonthTable from './StatsMonthTable.js';
import StatsFilter from './StatsFilter.js';
import {COMM_OK} from '../WsR2.js';
import {dStr} from '../Util.js';

const MT_LIST		= 0;
const MT_BY_CITY	= 1;

const MonthSpecByCity = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let counts ={};

	function monthGetCityName(id) {
		const city = gStorage.lists.citylist.list.find(c => c.id === id);
		return getCityName(city, gStorage.conn.user);
	}

	function sortByCityAndTime(o1, o2) {
		const ret = counts[o1.city_id] - counts[o2.city_id];
		if (ret !== 0)
			return ret;

		const ret2 = monthGetCityName(o2.city_id).localeCompare(monthGetCityName(o1.city_id, 'fi'));
		if (ret2 !== 0)
			return ret2;

		return o1.start_t - o2.start_t;
	}

	function getFormattedCityName(obs) {
		const city = gStorage.lists.citylist.list.find(x => x.id === obs.city_id);
		const usr = gStorage.conn.user;

		let a_str = '';

		if (city.country !== usr.def_country) {
			const country = gStorage.lists.countrylist.find(x => x.id === city.country);
			a_str = getCountryName(country, usr) + ', ';
		}

		a_str += getCityName(city, usr);

		return a_str;
	}

	function citySrc() {
		let prev_city = -1, i;
		let ret = [];

		gStorage.stats.obsList.forEach((obs) => {
			const key = obs.city_id;

			if (!counts[key]) {
				counts[key] = 1;
			} else {
				counts[key]++;
			}
		});

		const list = gStorage.stats.obsList.toSorted(sortByCityAndTime);

		for (i = list.length - 1; i >= 0 ; i--) {
			const obs = list[i];
			
			if (obs.city_id !== prev_city) {
				let j, n;

				n = 1;

				for (j = i - 1; j >= 0; j--) {
					let obs2 = list[j];

					if (obs.city_id !== obs2.city_id) 
						break;

					n++;
				}

				if (prev_city !== -1)
					ret.push(<TableRow key={-obs.city_id * 2 - 1}><TableCell colSpan={3}>&nbsp;</TableCell></TableRow>);

				ret.push(<TableRow key={-obs.city_id * 2} style={{backgroundColor: '#f0f0f0'}}><TableCell colSpan={3}>{(getFormattedCityName(obs)) + ' ' + n + ' ' + t('stats.species')}</TableCell></TableRow>);
			}

			const bg = obs.lifer ? '#cbffe2' : '#ffffff';

			ret.push(
				<TableRow key={i} style={{backgroundColor: bg}}>
					<TableCell>{getSpecName(gStorage.lists.speclist.list.find(elem => elem.id === obs.spec_id), gStorage.conn.user)}</TableCell>
					<TableCell>{dStr(obs.start_t)}</TableCell>
					<TableCell>{obs.addr}</TableCell>
				</TableRow>
			);


			prev_city = obs.city_id;
		}

		return ret;
	}

	if (!gStorage.stats.obsList || !gStorage.stats.obsList.length || gStorage.stats.month_tab !== MT_BY_CITY)
		return null;

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table size='small'>
				<TableHead>
					<TableRow>
						<TableCell>{t('main.location')}</TableCell>
						<TableCell>{t('main.time')}</TableCell>
						<TableCell>{t('main.species')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{citySrc()}
				</TableBody>
			</Table>
		</TableContainer>
	);
});

const StatsMonth = observer(() => {
	const [userAdjusted, setUserAdjusted] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function monthAddLeftEnabled() {
		return gStorage.stats.month !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_MONTH || gStorage.stats.rightList.month !== gStorage.stats.month ||
				gStorage.stats.rightList.year !== gStorage.stats.statsYear || 
				gStorage.stats.rightList.country !== gStorage.stats.country.id);
	}
	
	function monthAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_MONTH, year: gStorage.stats.statsYear, month: gStorage.stats.month, list: gStorage.stats.obsList.slice()});
	}

	function monthAddRightEnabled() {
		return gStorage.stats.month !== 0 && gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_MONTH || gStorage.stats.leftList.month !== gStorage.stats.month || 
				gStorage.stats.leftList.year !== gStorage.stats.statsYear ||
				gStorage.stats.leftList.country !== gStorage.stats.country.id);
	}
	
	function monthAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_MONTH, year: gStorage.stats.statsYear, month: gStorage.stats.month, list: gStorage.stats.obsList.slice()});
	}

	function monthChange(event) {
		const m = parseInt(event.target.value, 10);

    		gStorage.stats.setMonth(m);
		gStorage.stats.setObsList(null);

		setUserAdjusted(true);
	}

	function statsMonthYearChange(event) {
    		gStorage.stats.setStatsYear(parseInt(event.target.value, 10));
		gStorage.stats.setObsList(null);

		setUserAdjusted(true);
	}

	function monthRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('monthRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('monthRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH)
			return;

// 		console.log('monthRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function loadMonth() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'month',
			op: 'list',
			data: {
				country: gStorage.stats.country.id,
				year: gStorage.stats.statsYear,
				month: gStorage.stats.month,
			}
		}

// 		console.log('loadMonth', msg);
		gStorage.conn.ws.send(msg, monthRxWs);
	}

	function monthTabChange(e, value) {
		gStorage.stats.setMonthTab(value);
	}

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH)
		return null;

	if (!gStorage.stats.month && gStorage.conn.online && !userAdjusted) {
		gStorage.stats.setMonth(new Date().getMonth() + 1);
		gStorage.stats.setObsList(null);
	}

	if (!gStorage.stats.obsList && gStorage.stats.month > 0 && gStorage.stats.month <= 12  && gStorage.conn.online)
		loadMonth();

	return (
		<div>
			<Grid container direction="column" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<StatsFilter 
						loc = {{country: {
								value: gStorage.stats.country,
								style: {width: 200}
							}}
						}
						time = {{
							month: {
								month: gStorage.stats.month,
								onChange: monthChange,
								enabled: gStorage.conn.online
							},
							year: {
								year: gStorage.stats.statsYear,
								onChange: statsMonthYearChange,
								enabled: gStorage.conn.online,
								allowNone: true
							}}
						}
						compare = {{
							leftIsEnabled: monthAddLeftEnabled(),
							leftAdd: monthAddLeft,
							rightIsEnabled: monthAddRightEnabled(),
							rightAdd: monthAddRight,
							pos: 'month'
						}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<Tabs style={{width: 300, margin: 10}}
						id='monthtab'
						sx={{display: gStorage.stats.obsList && gStorage.stats.obsList.length ? 'block' : 'none'}}
						value={gStorage.stats.month_tab}
						onChange={monthTabChange} 
						align={'center'}
						indicatorColor="primary"
						textColor="primary"
						centered>
						<Tab
							value={MT_LIST}
							label={t('stats.month')}
							disabled={!gStorage.stats.obsList}/>
						<Tab
							value={MT_BY_CITY}
							label={t('stats.by_city')}
							disabled={!gStorage.stats.obsList}/>
					</Tabs>
				</Grid>
			</Grid>

			<StatsMonthTable src={gStorage.stats.month_tab === MT_LIST ? gStorage.stats.obsList : null} />
			<MonthSpecByCity />
		</div>
	);
});

export default StatsMonth;
